import React from 'react';
import PropTypes from 'prop-types';

function HitDeleteButton({onDelete, scratchpadId, deleteText}) {
    if (!onDelete) {
        return null;
    }

    function onClick(event) {
        event.preventDefault();
        onDelete(event, scratchpadId);
        event.stopPropagation();
    }

    return (
        <button
            aria-label={deleteText}
            className="scratchpad-hit-close card__close hidden-mini"
            onClick={onClick}
            data-wdio="tripboard-details__listing--delete"
        >
            <svg className="inline-svg" viewBox="-28 -14 50 50">
                <path d="M-3 35.4c-13.4 0-24.4-11-24.4-24.4 0-13.4 11-24.4 24.4-24.4 13.4 0 24.4 11 24.4 24.4 0 13.4-11 24.4-24.4 24.4zM-3-11c-12.2 0-22 9.8-22 22s9.8 22 22 22 22-9.8 22-22S9.3-11-3-11z"/>
                <path d="M-11.2 1.2l18 18L5.4 21l-18-18.2z"/>
                <g>
                    <path d="M5.2 1.2l1.6 1.6-18 18-1.7-1.5z"/>
                </g>
            </svg>
        </button>
    );
}

HitDeleteButton.propTypes = {
    onDelete: PropTypes.func,
    scratchpadId: PropTypes.string
};

export default HitDeleteButton;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitDeleteButton/HitDeleteButton.js